/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 使用用户名密码获取token信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  oauthPasswordDto: oauth2.OauthPasswordDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: oauth2.Token;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/oauth2/token-password`,
    data: oauthPasswordDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
